/**
 * Descargas de archivos del ERP (PDF / Word que devuelve el backend con
 * responseType 'blob'): guardar el Blob y leer el JSON de un error, que con
 * responseType 'blob' también llega como Blob.
 */

/** Descarga el contenido como archivo en el navegador */
export const saveBlob = (data, fileName, type) => {
  const blob = type ? new Blob([data], { type }) : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/** `response` del cuerpo de un error de axios (también si llegó como Blob); null si no hay JSON */
export const blobErrorBody = async (err) => {
  const data = err?.response?.data;
  if (data && typeof data.text === 'function') {
    try {
      return JSON.parse(await data.text())?.response || null;
    } catch (parseErr) {
      return null;
    }
  }
  return data?.response || null;
};
